import { render, staticRenderFns } from "./Vendorservices.vue?vue&type=template&id=5e67b590&scoped=true&"
import script from "./Vendorservices.vue?vue&type=script&lang=js&"
export * from "./Vendorservices.vue?vue&type=script&lang=js&"
import style0 from "./Vendorservices.vue?vue&type=style&index=0&id=5e67b590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67b590",
  null
  
)

export default component.exports